"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchShopStatusByShopId = exports.fetchShopByShopId = exports.fetchShopWhitelistNftByShopId = void 0;
async function fetchShopWhitelistNftByShopId(axiosInstance, shopId) {
    console.log('CandyShop: fetching shop whitelist nft');
    return axiosInstance.get(`/shop/wlNfts/${shopId}`).then((response) => response.data);
}
exports.fetchShopWhitelistNftByShopId = fetchShopWhitelistNftByShopId;
async function fetchShopByShopId(axiosInstance, shopId) {
    return axiosInstance.get(`/shop/id/${shopId}`).then((response) => response.data);
}
exports.fetchShopByShopId = fetchShopByShopId;
async function fetchShopStatusByShopId(axiosInstance, shopId) {
    return axiosInstance.get(`/status/${shopId}`).then((res) => res.data);
}
exports.fetchShopStatusByShopId = fetchShopStatusByShopId;
